export default __webpack_public_path__ + "static/media/dbline.c83bac3c.png";